package com.vamvisions.main.api.portfolio

import kotlinx.serialization.Serializable

/** A skill used in a project or an experience. [url] is absolute. */
@Serializable
data class SkillDto(
    val slug: String,
    val name: String,
    val description: String,
    val url: String,
)

@Serializable
enum class StoreDto { GOOGLE_PLAY, APP_STORE }

/** A project's page in [store]. [url] is absolute. */
@Serializable
data class StoreLinkDto(
    val store: StoreDto,
    val url: String,
)

/** Whether a project is out, or still being built. */
@Serializable
enum class ProjectStatusDto { PUBLISHED, COMING_SOON }

/**
 * A listed project. [description] may be empty. [year] is the release year, or the year work started on a coming-soon
 * project. [featured] marks current work. [meta] is a short localized line shown above the name, or null.
 * [iconUrl] is a site-relative path under `/media/`, [storeLinks] are its store pages in display order, at most one
 * per store. [websiteUrl] is the absolute URL of the live website, for a project used online. [sourceUrl] is the
 * absolute URL of the public source code. [privacyPolicySlug] is the slug of a document.
 */
@Serializable
data class ProjectDto(
    val slug: String,
    val name: String,
    val description: String,
    val year: Int,
    val status: ProjectStatusDto,
    val featured: Boolean,
    val meta: String?,
    val iconUrl: String,
    val storeLinks: List<StoreLinkDto>,
    val websiteUrl: String?,
    val sourceUrl: String?,
    val privacyPolicySlug: String?,
    val skills: List<SkillDto>,
)

@Serializable
data class ProjectListResponseDto(
    val items: List<ProjectDto>,
)
